// store/ProductModal.js
import React from 'react';

export function ProductModal({ data, onClose }) {
  if (!data) return null;

  const isLoading = data.loading;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="product-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        
        <div className="modal-content">
          <div className="product-image">
            {isLoading ? (
              <div className="skeleton" style={{ width: '100%', height: '100%' }}></div>
            ) : (
              <img 
                src={data.image || '/image_coming_soon.png'} 
                alt={data.name || "Product Image"} 
              />
            )}
          </div>
          
          <div className="product-details">
            {isLoading ? (
              <>
                <div className="skeleton skeleton-brand"></div>
                <div className="skeleton skeleton-title"></div>
                <div className="skeleton skeleton-price"></div>
              </>
            ) : (
              <>
                {/* <span className="brand-label">{data.brand || "Premium Part"}</span> */}
                <h2>{data.name || "Part Details"}</h2>
                <p className="price">{data.price || "Contact for Price"}</p>
              </>
            )}

            <div className="modal-actions">
              {isLoading ? (
                <>
                  <div className="skeleton" style={{ flex: 2, height: '54px', borderRadius: '12px' }}></div>
                  <div className="skeleton" style={{ flex: 1, height: '54px', borderRadius: '12px' }}></div>
                </>
              ) : (
                <>
                  {data.variantId && (
                    <a 
                      href={`https://${process.env.REACT_APP_SHOPIFY_DOMAIN || 'autoshopping24.com'}/cart/${data.variantId}:1`} 
                      className="buy-now-main"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Checkout Now
                    </a>
                  )}
                  <a 
                    href={data.link || `https://${process.env.REACT_APP_SHOPIFY_DOMAIN || 'autoshopping24.com'}`} 
                    className="view-store-link"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    View in Store
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
